export default __webpack_public_path__ + "static/create-insights-light-240c22660afce5d265f0d7abe96ca33d.png";